module.exports = __webpack_public_path__ + "static/TTNormsPro-Bold-cf371bd8dd2f3e276f94b0db5ed2b202.woff2";